Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLoadingPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = withLoading;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getComponentName = require('airbnb-prop-types/build/helpers/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _LoadingProvider = require('./LoadingProvider');

var _brcast = require('../shapes/brcast');

var _brcast2 = _interopRequireDefault(_brcast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // This higher-order-function consumes a boolean from React context that is
// provided by the LoadingProvider component. We can use this to create subtrees
// of our application that render as a loading state.
//
// We ideally want this to be as seamless and easy to use as possible, so we
// have baked this in to low-level components, like BaseText. These components
// render a Shimmer component when the loading state has been provided. Ideally,
// this will allow you to maintain the same layout as the loaded state, but
// rendered progressively while the data is being fetched. We hope that this
// will be a nicer experience than seeing a generic spinner.

/* eslint-disable react/prefer-stateless-function */


var contextTypes = _defineProperty({}, _LoadingProvider.CHANNEL, _brcast2['default']);

var propTypes = {
  noLoading: _propTypes2['default'].bool
};

var defaultProps = {
  noLoading: false
};

// export for convenience, in order for components to spread these onto their propTypes
var withLoadingPropTypes = exports.withLoadingPropTypes = {
  isLoading: _propTypes2['default'].bool.isRequired
};

function withLoading(WrappedComponent) {
  var WithLoading = function (_React$Component) {
    _inherits(WithLoading, _React$Component);

    function WithLoading(props, context) {
      _classCallCheck(this, WithLoading);

      var _this = _possibleConstructorReturn(this, (WithLoading.__proto__ || Object.getPrototypeOf(WithLoading)).call(this, props, context));

      _this.state = {
        isLoading: context[_LoadingProvider.CHANNEL] ? context[_LoadingProvider.CHANNEL].getState() : false
      };
      return _this;
    }

    _createClass(WithLoading, [{
      key: 'componentDidMount',
      value: function () {
        function componentDidMount() {
          var _this2 = this;

          if (this.context[_LoadingProvider.CHANNEL]) {
            // subscribe to future loading changes
            this.unsubscribe = this.context[_LoadingProvider.CHANNEL].subscribe(function (isLoading) {
              _this2.setState({
                isLoading: isLoading
              });
            });
          }
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function () {
        function componentWillUnmount() {
          if (this.unsubscribe) {
            this.unsubscribe();
          }
        }

        return componentWillUnmount;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var isLoading = this.state.isLoading;

          var _props = this.props,
              noLoading = _props.noLoading,
              restProps = _objectWithoutProperties(_props, ['noLoading']);

          return _react2['default'].createElement(WrappedComponent, _extends({}, restProps, {
            isLoading: !noLoading && isLoading
          }));
        }

        return render;
      }()
    }]);

    return WithLoading;
  }(_react2['default'].Component);

  WithLoading.componentCategory = 'Core';
  WithLoading.displayName = 'WithLoading';


  WithLoading.WrappedComponent = WrappedComponent;
  WithLoading.contextTypes = contextTypes;
  WithLoading.propTypes = propTypes;
  WithLoading.defaultProps = defaultProps;

  var wrappedComponentName = (0, _getComponentName2['default'])(WrappedComponent) || 'Component';
  WithLoading.displayName = 'withLoading(' + String(wrappedComponentName) + ')';

  return (0, _hoistNonReactStatics2['default'])(WithLoading, WrappedComponent);
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/withLoading.js
// module id = 91
// module chunks = 168707334958949